import MobileDetect from 'mobile-detect'

export default function platform() {
    let device = 'web';

    if (new MobileDetect(window.navigator.userAgent).mobile() || new MobileDetect(window.navigator.userAgent).tablet()) {
        device = 'mobile'
    }
    return device;
}